export class PromotionPriceViewModel{
    promotionId:any;
    promotionCode:any;
    isSend:boolean;
    customerId:any;
}